import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../../context/AppDataContext';

const CellActions = (props) =>{
    return(
        <>
            <Link to={"/proposal/details/"+props.data.id} className='btn btn-outline-primary btn-sm' >{props.value}</Link>
        </>
    )
}


function ProposalGrid({proposalList}) {

    const gridRef = useRef()
    const {userDD,partyDD,getDDDataById} = useAppData();
    
    const [defaultColDef] = useState({
        floatingFilter: true,
        filterParams: {
          buttons: ['apply'],
        },
        resizable: true,
        width:120,
        filter:true,
        sortable: true,
        cellStyle: { 'textTransform': 'uppercase' },
    });
        
        
    const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
        let _columnDefs = [

            {field:"id",headerName: "Proposal #"},

            {field:"partyId",headerName: "party", width:300,
                cellRenderer: CellActions,
                valueGetter:params=>{
                    return getDDDataById(partyDD,params.data.partyId)? getDDDataById(partyDD,params.data.partyId).label : "--";
                }
                
            },
            
            {headerName: "Created By", width:250,
              valueGetter:params=>{
                return getDDDataById(userDD,params.data.userId).label;
              }
            },
            {field:"proposalDate",headerName: "Proposal Date",width:150},
            {field:"created_at",headerName: "Created On",width:150},
            {field:"updated_at",headerName: "Last Updated on",width:150},
               
        ];
        setColumnDef(_columnDefs);
    }
    
    const onBtnExport = () => {
        gridRef.current.api.exportDataAsCsv("data.csv");
    };
    useEffect(()=>{    
        prepairColumnDef();
    },[]);

    return (
        <div className="ag-theme-alpine" style={{height: 550}}>
          <AgGridReact
            ref={gridRef}
            rowData={proposalList}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            animateRows={true}
          />
        </div>                
    )
}

export default ProposalGrid